module.exports = __webpack_public_path__ + "static/media/cq_notifiche b.fd5ee8b3.svg";